import React, { useCallback, useRef, useState } from 'react';

import { down } from '@/assets/icons';
import { classNames } from '@/helpers/classNames';
import { SvgIcon } from '@material-ui/core';

import styles from './CollapsableSection.module.scss';

type CollapsableSectionProps = {
	title: string;
	subtitle?: string;
	className?: string;
	titleClassName?: string;
	subtitleClassName?: string;
	contentClassName?: string;
	uncollapsable?: boolean;
};

export const CollapsableSection: React.FC<CollapsableSectionProps> = ({
	title,
	subtitle,
	className,
	titleClassName,
	subtitleClassName,
	contentClassName,
	uncollapsable,
	children,
}) => {
	const contentRef = useRef<HTMLDivElement>(null);
	const [isCollapsed, setIsCollapsed] = useState(true);
	const classes = classNames([styles.collapsablesection, className]);

	return (
		<div className={classes}>
			<div
				className={styles['row']}
				onClick={() => {
					if (!uncollapsable) {
						setIsCollapsed((state) => !state);
					}
				}}
			>
				<div className={styles['left-items']}>
					<div
						className={classNames([
							styles['title'],
							titleClassName,
						])}
					>
						{title}
					</div>
					{subtitle && (
						<div
							className={classNames([
								styles['subtitle'],
								subtitleClassName,
							])}
						>
							{subtitle}
						</div>
					)}
				</div>
				{!uncollapsable && (
					<SvgIcon
						component={down}
						className={classNames([
							styles['chevron'],
							!isCollapsed && styles['active'],
						])}
					/>
				)}
			</div>
			<div
				ref={contentRef}
				className={classNames([
					styles['content'],
					!isCollapsed && styles['active'],
					contentClassName,
				])}
				style={{
					maxHeight:
						!isCollapsed && contentRef.current
							? contentRef.current.scrollHeight
							: '0',
				}}
			>
				{children}
			</div>
		</div>
	);
};
